'use client';

import { useState, useEffect } from 'react';
import { usePathname } from 'next/navigation';

interface OrientationState {
  showSuggestion: boolean;
  isPortrait: boolean;
  isMobile: boolean;
}

export const useOrientationSuggestion = () => {
  const pathname = usePathname();
  const [state, setState] = useState<OrientationState>({
    showSuggestion: false,
    isPortrait: false,
    isMobile: false,
  });

  useEffect(() => {
    const checkOrientation = () => {
      try {
        const isMobile = window.innerWidth <= 640;
        const isPortrait = window.innerHeight > window.innerWidth;
        const isPostsPage = pathname?.startsWith('/posts');

        const shouldShow =
          isMobile &&
          isPortrait &&
          !isPostsPage &&
          !localStorage.getItem('orientation-suggestion-dismissed');

        setState({
          showSuggestion: shouldShow,
          isPortrait,
          isMobile,
        });
      } catch (error) {
        console.warn('Orientation check failed:', error);
      }
    };

    // Add passive listeners for better performance
    const options = { passive: true };
    
    checkOrientation();

    window.addEventListener('resize', checkOrientation, options);
    window.addEventListener('orientationchange', checkOrientation, options);

    return () => {
      window.removeEventListener('resize', checkOrientation);
      window.removeEventListener('orientationchange', checkOrientation);
    };
  }, [pathname]);

  const dismissSuggestion = () => {
    localStorage.setItem('orientation-suggestion-dismissed', 'true');
    setState((prev) => ({ ...prev, showSuggestion: false }));
  };

  return {
    ...state,
    dismissSuggestion,
  };
};
